import { Form, FormikProvider, useFormik } from "formik";
import React from "react";
import { z } from "zod";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { VStack } from "@design-system/VStack/VStack";
import { validateFormikWithZodSchema } from "@helpers/form";
import { UpdateProfileFormProps } from "./types";

interface Value {
    email: string;
}

const fields = createFormikFields<Value>();

const updateEmailFormSchema = z.object({
    email: z
        .string()
        .min(1, "Email is required")
        .email("Please provide a valid email address"),
});

export const UpdateEmailForm: React.FC<UpdateProfileFormProps<Value>> = ({
    email,
    onSubmit,
    children,
}) => {
    const formik = useFormik<Value>({
        initialValues: {
            email,
        },
        validate: validateFormikWithZodSchema(updateEmailFormSchema),
        onSubmit,
    });

    return (
        <FormikProvider value={formik}>
            <Form>
                <VStack gap={16}>
                    <fields.Text
                        name="email"
                        type="email"
                        label="Email"
                        size="xl"
                    />
                    {children(formik.isValid)}
                </VStack>
            </Form>
        </FormikProvider>
    );
};
